import { ApolloClient, InMemoryCache } from '@apollo/client';
import { GraphQLAuthHeader } from '../constants/constant';
import ServerSideDataSource from './ServerSideDataSource';
import ApiEndpoints from '../constants/apiconstants';
import { getCurrentEnv } from '../helper/helper';
import * as queryBuilder from './queryBuilder/tableQueryBuilder';

let headers = {};
if (getCurrentEnv() === 'local') {
	headers.Authorization = GraphQLAuthHeader;
}

const client = new ApolloClient({
	uri: ApiEndpoints.TABLE_GRAPHQL,
	cache: new InMemoryCache({
		addTypename: false,
	}),
	headers,
});

export { queryBuilder, ServerSideDataSource };

export default client;
